/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict"

    interface ISavedProgramsMajors {
    }

    class SavedProgramsMajors implements ISavedProgramsMajors {
        static $inject: Array<string> = ["common", "Restangular", "$routeParams", "$q", "config"];
        static controllerId: string = "savedPrograms";

        urlName: string;
        programs: any;
        loading: boolean = true;
        programLength: any;
        pageNumber: any;
        umbracoUrl: string;
        cfncUrl: string;
        slickConfig: any;
        log: (msg, data?, showToast?) => void;
        logError: (msg, data?, showToast?) => void;
        logSuccess: (msg, data?, showToast?) => void;

        constructor(private common: ICommonFactory, private Restangular: Restangular.IService, private $routeParams: ng.route.IRouteParamsService, private $q: ng.IQService, private config: IConfig) {
            this.log = common.logger.getLogFn(SavedProgramsMajors.controllerId);
            this.logError = common.logger.getLogFn(SavedProgramsMajors.controllerId, "error");
            this.logSuccess = common.logger.getLogFn(SavedProgramsMajors.controllerId, "success");
            this.log = common.logger.getLogFn(SavedProgramsMajors.controllerId);
            this.pageNumber = 1;
            this.urlName = $routeParams.program;
            this.umbracoUrl = this.config.umbracoUrl;
            this.cfncUrl = this.config.cfncUrl;
            this.slickConfig = {
                slidesToShow: 3,
                dots: false,
                arrows: false,
                centerMode: true,
                infinite: false,
                variableWidth: true,
                focusOnSelect: true
            };
            this.activate();
        }

        activate() {
            var promises = [this.getSavedPrograms()];
            this.common.activateController(promises, SavedProgramsMajors.controllerId)
                .then(() => {
                    this.loading = false;
                });
        }

        getSavedPrograms(): ng.IPromise<void> {
            var queryParams = { pageNumber: this.pageNumber };
            return this.Restangular.one("programsMajors/getSavedPrograms").get(queryParams).then((results) => {
                this.programs = results;
            }, (reason) => {
                console.error(reason);
            });
        }

        deleteProgram = (savedCollege: any, location: number) => {
            console.log(savedCollege);
            this.Restangular.all("collegePlanning/deleteSavedProgram").post(savedCollege).then((results) => {
                this.logSuccess("Your saved college changes have been saved", null, true);
                this.getSavedPrograms();
            }, (reason) => {
                    this.logError("An error occurred while processing your request.", reason, true);
                console.error(reason);
            });
        }
    }
    angular.module("app").controller(SavedProgramsMajors.controllerId, SavedProgramsMajors);
} 